import React from 'react';

import RedirectNavigate from './redirectNavigate';
import RenderPage from './renderPage';

import usePreviewQuery from 'hooks/usePreviewQuery';
import { getStaticHomeService } from 'services/pages';
import { useAppSelector } from 'store/hooks';

const HomeNavigate: React.FC = () => {
  const language = useAppSelector((state) => state.system.language);

  const {
    isLoading,
    data,
    error,
  } = usePreviewQuery<
  BasePageDataTypes<any>,
  BasePageDataTypes<any>
  >(
    'GetHomeData',
    () => getStaticHomeService(),
    language,
  );

  if (isLoading) {
    return null;
  }

  if (error) {
    return <RedirectNavigate error={error} />;
  }

  return <RenderPage pageData={data} isHome />;
};

export default HomeNavigate;
